module.exports = __webpack_public_path__ + "static/media/gryphon-house-exterior-entrance.bca50f61.jpg";